











export default {
  name: 'EyeInbox',
  props: {
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
